import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ModalConfirmacion from "./ModalConfirmacion";
import Utils from "../../../../utils/Utils";
import { ACCION_GRUPO } from "../../hooks/useAccionesGrupoN2";

/**
 * Confirmación para eliminar un grupo de Nave 2 o forzarlo como completado.
 * Al completar ofrece forzar también como preparados sus pedidos pendientes, que si no
 * volverían a la lista de pedidos al liberarse del grupo
 */
const ModalAccionGrupoN2 = ({
    accion,
    pedidosPendientes,
    forzarPedidos,
    onForzarPedidosChange,
    loading,
    onHide,
    onConfirm
}) => {
    const grupo = accion?.grupo;
    const esEliminar = accion?.tipo === ACCION_GRUPO.ELIMINAR;
    const estadisticas = grupo?.estadisticas || {};

    const detalles = grupo ? [
        { label: "Grupo", value: grupo.nombre },
        { label: "Pedidos", value: String(estadisticas.totalPedidos ?? grupo.pedidos?.length ?? 0) },
        { label: "Progreso", value: `${estadisticas.progreso || 0}%` },
        { label: "Preparador", value: grupo.preparador ? Utils.toCapitalize(grupo.preparador) : "Sin asignar" }
    ] : [];

    const numPendientes = pedidosPendientes.length;

    return (
        <ModalConfirmacion
            show={Boolean(accion)}
            onHide={onHide}
            onConfirm={onConfirm}
            loading={loading}
            title={esEliminar ? "Eliminar grupo" : "Forzar grupo como completado"}
            titleMobile={esEliminar ? "Eliminar grupo" : "Completar grupo"}
            text={esEliminar
                ? "Se eliminará el grupo y sus pedidos <strong>volverán a estar disponibles</strong> para agruparlos de nuevo."
                : "El grupo se marcará como <strong>completado</strong> y desaparecerá de los grupos activos, aunque no se haya terminado de puntear."}
            detalles={detalles}
            confirmLabel={esEliminar ? "Eliminar grupo" : "Forzar completado"}
            confirmLabelMobile={esEliminar ? "Eliminar" : "Completar"}
            icon={esEliminar ? DeleteIcon : DoneAllIcon}
            confirmIcon={esEliminar ? DeleteIcon : DoneAllIcon}
        >
            {!esEliminar && (
                <Box sx={{ mt: { xs: 2, sm: 2.5 } }}>
                    {numPendientes > 0 ? (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={forzarPedidos}
                                    onChange={(e) => onForzarPedidosChange(e.target.checked)}
                                    disabled={loading}
                                    sx={{ "&.Mui-checked": { color: "#cc071e" } }}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: { xs: 13, sm: 14 }, color: "#495057" }}>
                                    Marcar también como preparados sus <strong>{numPendientes} {numPendientes === 1 ? "pedido pendiente" : "pedidos pendientes"}</strong> ({pedidosPendientes.map((p) => p.num).join(", ")}), sin avisar a nave 1. Si no, volverán a la lista de pedidos.
                                </Typography>
                            }
                            sx={{ alignItems: "flex-start", m: 0, "& .MuiCheckbox-root": { pt: 0, pl: 0 } }}
                        />
                    ) : (
                        <Typography sx={{ fontSize: { xs: 13, sm: 14 }, color: "#6c757d" }}>
                            Ningún pedido del grupo sigue pendiente en la lista de nave 2.
                        </Typography>
                    )}
                </Box>
            )}
        </ModalConfirmacion>
    );
};

export default ModalAccionGrupoN2;
